import { GetterTreeWithRootState } from '~/store/types'
import { ThemeState } from '~/store/modules/shared/theme/state'
import { Theme } from '~/constants/theme/theme'

export default {
  themeIsDark(state) {
    return state.activeTheme === Theme.DARK
  },
  themeIsLight(state) {
    return state.activeTheme === Theme.LIGHT
  }
} as GetterTreeWithRootState<ThemeState>
